import branchManagementDepositReportsComponent from './deposit_reports.component';

let branchManagementDepositReportsModule = angular.module('branchManagementDepositReports', [])
  .component('branchManagementDepositReports', branchManagementDepositReportsComponent)
  .name;

export default branchManagementDepositReportsModule; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/deposit_reports/index.js